import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { typedMemo } from '@utils';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  icon: React.ElementType;
  textKey: string;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  fullScreen?: boolean;
  actionButton?: { labelKey: string; onClick: () => void };
}

export const EmptyState = typedMemo(
  ({
    icon: IconComponent,
    textKey,
    color,
    fullScreen,
    actionButton,
  }: Readonly<EmptyStateProps>) => {
    const { t } = useTranslation();
    return (
      <div
        className={clsx([
          styles.outerContainer,
          fullScreen && styles.fullScreen,
        ])}
      >
        <div className={styles.innerContainer}>
          {IconComponent && (
            <div className={styles.icon}>
              <IconComponent color={color || 'disabled'} />
            </div>
          )}
          <Typography variant="h3">{t(textKey)}</Typography>
          {actionButton && (
            <Button
              variant="contained"
              onClick={actionButton.onClick}
              sx={{ marginTop: 2 }}
            >
              {t(actionButton.labelKey)}
            </Button>
          )}
        </div>
      </div>
    );
  },
);
